import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ActionButtonModel } from '../../../models/core/action-button.model';
import { ActionResultModel } from '../../../models/core/action-result.model';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { ActionButtonsService } from '../../../services/action-buttons.service';

@Component({
    selector: 'sl-server-response',
    templateUrl: './server-response.component.html',
    styleUrls: ['./server-response.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServerResponseComponent implements OnInit {
    relatedActions: ActionButtonModel[] = [];

    readonly data = inject<ApiResponseModel<ActionResultModel>>(MAT_DIALOG_DATA);
    private readonly actionButtonsService = inject(ActionButtonsService);

    ngOnInit(): void {
        this.relatedActions = this.actionButtonsService.convert(this.data.relatedActions);
    }
}
